export default {
  title: 'ค่าใช้จ่าย',
  totals: {
    including_vat: 'รวม (รวม VAT)',
    excluding_vat: 'รวม (ไม่รวม VAT)',
  },
  labels: {
    date: 'วันที่จ่าย',
    category: 'หมวดหมู่',
    amount: 'จำนวนเงิน',
    vat_amount: 'ภาษีมูลค่าเพิ่ม',
    transaction_fee: 'ค่าธรรมเนียมการโอน',
    total_amount: 'ยอดรวม',
    vendor_name: 'ผู้ขาย/ร้านค้า',
    vendor: 'ผู้ขาย/ร้านค้า',
    description: 'รายละเอียด',
    payment_method: 'วิธีชำระเงิน',
    notes: 'บันทึก',
    property: 'อสังหาริมทรัพย์',
    receipt: 'ใบเสร็จ',
    receipt_images: 'ใบเสร็จ / ใบกำกับภาษี',
    evidence_images: 'เอกสารประกอบ',
    wht_rate: 'อัตราภาษีหัก ณ ที่จ่าย',
    wht_amount: 'จำนวนภาษีหัก ณ ที่จ่าย',
    net_cash_amount: 'ยอดเงินสุทธิ',
    created_by: 'บันทึกโดย',
    status: 'สถานะ',
    paid_by: 'ผู้ชำระเงิน',
    approved_by: 'อนุมัติโดย',
    reimbursed_at: 'วันที่เบิกจ่าย',
    maintenance_request: 'งานซ่อมที่เชื่อมโยง',
    reconciled: 'จับคู่แล้ว',
    not_reconciled: 'ยังไม่ได้จับคู่',
    lease: 'สัญญาเช่า',
    unit: 'ห้อง',
  },
  placeholders: {
    vendor_name: 'กรอกชื่อผู้ขาย/ร้านค้า',
    description: 'กรอกรายละเอียด',
    notes: 'บันทึกเพิ่มเติม',
    paid_by: 'ชื่อผู้ที่ชำระเงิน',
    transaction_fee: 'เช่น ค่าธรรมเนียมโอนเงิน',
    search: 'ค้นหาผู้ขายหรือรายละเอียด...',
    search_vendor: 'ค้นหาผู้ขาย...',
    wht_rate_custom: 'เช่น 0.025',
  },
  wht_presets: {
    none: 'ไม่มี',
    rate_1: '1%',
    rate_1_5: '1.5%',
    rate_2: '2%',
    rate_3: '3%',
    rate_5: '5%',
    rate_10: '10%',
    custom: 'กำหนดเอง',
  },
  sections: {
    reconciliation: 'การกระทบยอดบัญชี',
    withholding_tax: 'ภาษีหัก ณ ที่จ่าย',
    evidence: 'เอกสารแนบ',
  },
  lease_chip: {
    linked_to: 'เชื่อมกับสัญญาเช่า {{leaseCode}} · ห้อง {{unitNumber}}',
    view_lease: 'ดูสัญญา',
  },
  messages_detail: {
    no_attachments: 'ไม่มีเอกสารแนบ',
  },
  messages: {
    delete_confirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบค่าใช้จ่ายนี้?',
    delete_success: 'ลบค่าใช้จ่ายเรียบร้อยแล้ว',
    create_success: 'บันทึกค่าใช้จ่ายเรียบร้อยแล้ว',
    update_success: 'อัปเดตค่าใช้จ่ายเรียบร้อยแล้ว',
    reimburse_confirm: 'อนุมัติการเบิกจ่ายสำหรับค่าใช้จ่ายนี้?',
    reimburse_success: 'อนุมัติการเบิกจ่ายแล้ว',
    complete_confirm: 'ยืนยันว่าการเบิกจ่ายเสร็จสมบูรณ์?',
    complete_success: 'บันทึกค่าใช้จ่ายเป็นเสร็จสิ้นแล้ว',
    confirm_expense_confirm: 'ยืนยันค่าใช้จ่ายนี้?',
    confirm_expense_success: 'ยืนยันค่าใช้จ่ายแล้ว',
    no_wht_template: 'ไม่พบเทมเพลตหนังสือ 50 ทวิ กรุณาตั้งค่าใน "ตั้งค่า → เทมเพลต"',
    no_reimbursement_template: 'ไม่พบเทมเพลตใบสำคัญจ่าย กรุณาตั้งค่าใน "ตั้งค่า → เทมเพลต"',
  },
  actions: {
    new_expense: 'เพิ่มค่าใช้จ่าย',
    edit_expense: 'แก้ไขค่าใช้จ่าย',
    reimburse: 'อนุมัติการเบิกจ่าย',
    mark_complete: 'บันทึกว่าเสร็จสิ้น',
    confirm_expense: 'ยืนยันค่าใช้จ่าย',
    export_csv: 'ส่งออก CSV',
    create_vendor: 'เพิ่มผู้ขายใหม่',
    enter_manually: 'หรือกรอกเอง',
    generate_wht_certificate: 'สร้างหนังสือ 50 ทวิ',
    download_reimbursement_receipt: 'ดาวน์โหลดใบสำคัญจ่าย',
  },
  empty: {
    title: 'ยังไม่มีค่าใช้จ่าย',
    description: 'เริ่มติดตามค่าใช้จ่ายของอสังหาริมทรัพย์',
  },
  statuses: {
    completed: 'เสร็จสิ้น',
    pending_reimbursement_approval: 'รอเบิกจ่าย',
    reimbursement_approved: 'อนุมัติเบิกจ่ายแล้ว',
    pending_confirmation: 'รอยืนยัน',
  },
  payment_methods: {
    cash: 'เงินสด',
    bank_transfer: 'โอนเงิน',
    cheque: 'เช็ค',
    credit_card: 'บัตรเครดิต',
    direct_debit: 'หักบัญชี',
    other: 'อื่นๆ',
  },
  categories: {
    repairs: 'ค่าซ่อมบำรุง',
    utilities: 'ค่าน้ำ-ไฟส่วนกลาง',
    insurance: 'ค่าประกันภัย',
    property_tax: 'ภาษีที่ดินและสิ่งปลูกสร้าง',
    labor: 'ค่าแรงงาน',
    supplies: 'ค่าวัสดุสิ้นเปลือง',
    cleaning: 'ค่าทำความสะอาด',
    security: 'ค่ารักษาความปลอดภัย',
    management_fee: 'ค่าบริหารจัดการ',
    office_equipment: 'อุปกรณ์สำนักงาน',
    other: 'อื่นๆ',
    deposit_return: 'คืนเงินประกัน',
    // EP-156 (T156-009/T156-010, §3.3) — the one expense POST /api/leases/:id/end
    // may create: the sum of ค่าแรกเข้า and/or the key-card deposit.
    move_in_refund: 'คืนค่าแรกเข้า / มัดจำคีย์การ์ด',
  },
  setup_guide: {
    title: 'ติดตามค่าใช้จ่ายของอสังหาริมทรัพย์',
    description: 'บันทึกและจัดหมวดหมู่ค่าใช้จ่ายในแต่ละอสังหาริมทรัพย์ ติดตามการจ่ายเงินให้ผู้ขาย จัดการการเบิกจ่าย และสร้างรายงานทางการเงิน',
    prerequisites_title: 'ก่อนเริ่มต้น',
    prereq_property: 'มีอสังหาริมทรัพย์อย่างน้อย 1 แห่ง',
    prereq_setup_property: 'สร้างอสังหาริมทรัพย์',
    step_1_title: 'บันทึกค่าใช้จ่าย',
    step_1_description: 'เพิ่มค่าใช้จ่ายแรกพร้อมหมวดหมู่ จำนวนเงิน และรายละเอียดผู้ขาย',
    step_2_title: 'จัดหมวดหมู่และติดตาม',
    step_2_description: 'ใช้หมวดหมู่ในการจัดระเบียบค่าใช้จ่ายและติดตามรูปแบบการใช้จ่าย',
    step_3_title: 'ดูรายงาน',
    step_3_description: 'ดูสรุปค่าใช้จ่าย แนวโน้ม และรายงานกำไรขาดทุน',
  },
  filters: {
    all_statuses: 'ทุกสถานะ',
    all_categories: 'ทุกหมวดหมู่',
    date_from: 'ตั้งแต่',
    date_to: 'ถึง',
    missing_receipt: 'ไม่มีใบเสร็จ',
    has_wht: 'มีภาษีหัก ณ ที่จ่าย',
  },

  errors: {
    validation_failed: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบแบบฟอร์มอีกครั้ง',

    fields: {
      property_id: 'อสังหาริมทรัพย์',
      category: 'หมวดหมู่',
      amount: 'จำนวนเงิน',
      vat_amount: 'ภาษีมูลค่าเพิ่ม',
      transaction_fee: 'ค่าธรรมเนียม',
      expense_date: 'วันที่จ่าย',
      vendor_name: 'ผู้ขาย',
      payment_method: 'วิธีชำระเงิน',
    },

    codes: {
      blank: 'ต้องไม่เว้นว่าง',
      taken: 'ถูกใช้แล้ว',
      invalid: 'ไม่ถูกต้อง',
      too_short: 'สั้นเกินไป',
      too_long: 'ยาวเกินไป',
      greater_than: 'ต้องมากกว่าค่าที่กำหนด',
      greater_than_or_equal_to: 'ต้องมากกว่าหรือเท่ากับค่าที่กำหนด',
      less_than: 'ต้องน้อยกว่าค่าที่กำหนด',
      less_than_or_equal_to: 'ต้องน้อยกว่าหรือเท่ากับค่าที่กำหนด',
      not_a_number: 'ต้องเป็นตัวเลข',
      inclusion: 'ค่าไม่อยู่ในรายการที่อนุญาต',
    },
  },
}
